import { useContext } from "react";
import { NotificationContext } from "./context";

export const useNotifications = () => useContext(NotificationContext);
